export const getCaptchaToken = () => {
    return new Promise(function (resolve) {
        grecaptcha.ready(() => {
            grecaptcha.execute(document.grecaptchaHandle).then((token) => {
                resolve(token)
            })
        })
    })
}